<template>

    <a href="" id="start-guide" class="support-floating-icon" @click.stop.prevent="startGuide()">
        <span>{{ $t('how_can_i_help_you') }}</span>
    </a>

</template>

<script>
import Driver from "driver.js" // import driver.js
import "driver.js/dist/driver.min.css" // import driver.js css

import homepageStepsCS from "./Steps/cs/homepageSteps"
import homepageStepsEN from "./Steps/en/homepageSteps"
import homepageStepsSK from "./Steps/sk/homepageSteps"

import careerStepsCS from "./Steps/cs/careerSteps"
import careerStepsEN from "./Steps/en/careerSteps"
import careerStepsSK from "./Steps/sk/careerSteps"

import careerSiteStepsCS from "./Steps/cs/careerSiteSteps"
import careerSiteStepsEN from "./Steps/en/careerSiteSteps"
import careerSiteStepsSK from "./Steps/sk/careerSiteSteps"

import talentpoolStepsCS from "./Steps/cs/talentpoolSteps"
import talentpoolStepsEN from "./Steps/en/talentpoolSteps"
import talentpoolStepsSK from "./Steps/sk/talentpoolSteps"

import hiringStepsCS from "./Steps/cs/hiringSteps"
import hiringStepsEN from "./Steps/en/hiringSteps"
import hiringStepsSK from "./Steps/sk/hiringSteps"

import onboardingStepsCS from "./Steps/cs/onboardingSteps"
import onboardingStepsEN from "./Steps/en/onboardingSteps"
import onboardingStepsSK from "./Steps/sk/onboardingSteps"

import onboardingSiteStepsCS from "./Steps/cs/onboardingSiteSteps"
import onboardingSiteStepsEN from "./Steps/en/onboardingSiteSteps"
import onboardingSiteStepsSK from "./Steps/sk/onboardingSiteSteps"

import onboardingChecklistStepsCS from "./Steps/cs/onboardingChecklistSteps"
import onboardingChecklistStepsEN from "./Steps/en/onboardingChecklistSteps"
import onboardingChecklistStepsSK from "./Steps/sk/onboardingChecklistSteps"

export default {
  name: "Guide",
  data () {
    return {
      driver: null
    }
  },
  mounted () {
    this.driver = new Driver({
        // className to wrap driver.js popover
      className: 'scoped-class',

      // enable the animation
      animate: true,

      // background opacity
      opacity: 0.6,

      // padding of element
      padding: 10,

      // is closable?
      allowClose: true,

      // Allow controlling through keyboard (escape to close, arrow keys to move)
      keyboardControl: true,

      // Whether the click on overlay should move next
      overlayClickNext: false,

      // text on the Done button
      doneBtnText: 'Done',

      // text on the Close button
      closeBtnText: 'Close',

      // background color
      stageBackground: '#ffffff',

      // text on the Next button
      nextBtnText: this.$t('guide_next'),

      // text on the Prev button
      prevBtnText: this.$t('guide_previous'),

      // text on the Prev button
      closeBtnText: this.$t('guide_close'),

      DoneBtnText: this.$t('guide_continue_to_next_page'), // Text on the final button

      // shows navigation buttons
      showButtons: true,

      // Put the close button as an X on the top right corner of popover
      xCloseButton: true,

      overlayClickNext: false,

        onNext: () => {
            this.driver.refresh();
        },

        onDeselected: () => {

        },
      onReset: () => {
          // Prevent popping up again after reload
          // this.driver.refresh();
          this.stopGuide();

        },


    });

    let currentLang = window.localStorage.getItem('app-language');
    let _this = this;

    setTimeout(function(){

      if(currentLang == "en"){
          if(window.location.pathname == '/jobs'){
              _this.driver.defineSteps(careerStepsEN);

          } else if(window.location.pathname == '/hiring'){
              _this.driver.defineSteps(hiringStepsEN);

          } else if(window.location.pathname == '/onboarding'){
              _this.driver.defineSteps(onboardingStepsEN);

          } else if(window.location.pathname == '/onboarding/checklist'){
              _this.driver.defineSteps(onboardingChecklistStepsEN);

          } else if(window.location.pathname == '/talentpool'){
              _this.driver.defineSteps(talentpoolStepsEN);

          } else if(window.location.pathname.indexOf("dashboard") > -1){
              _this.driver.defineSteps(homepageStepsEN);

          } else if(window.location.pathname.indexOf("careersite") > -1) {
              _this.driver.defineSteps(careerSiteStepsEN);

          } else if(window.location.pathname.indexOf("/stranka") > -1){
              _this.driver.defineSteps(onboardingSiteStepsEN);

          } else {
            $("#start-guide").fadeOut();
          }
      } else if (currentLang == "sk"){
          if(window.location.pathname == '/jobs'){
              _this.driver.defineSteps(careerStepsSK);

          } else if(window.location.pathname == '/hiring'){
              _this.driver.defineSteps(hiringStepsSK);

          } else if(window.location.pathname == '/onboarding'){
              _this.driver.defineSteps(onboardingStepsSK);

          } else if(window.location.pathname == '/onboarding/checklist'){
              _this.driver.defineSteps(onboardingChecklistStepsSK);

          } else if(window.location.pathname == '/talentpool'){
              _this.driver.defineSteps(talentpoolStepsSK);

          } else if(window.location.pathname.indexOf("dashboard") > -1){
              _this.driver.defineSteps(homepageStepsSK);

          } else if(window.location.pathname.indexOf("careersite") > -1) {
              _this.driver.defineSteps(careerSiteStepsSK);

          } else if(window.location.pathname.indexOf("/stranka") > -1){
              _this.driver.defineSteps(onboardingSiteStepsSK);

          } else {
            $("#start-guide").fadeOut();
          }
      } else {
          if(window.location.pathname == '/jobs'){
              _this.driver.defineSteps(careerStepsCS);

          } else if(window.location.pathname == '/hiring'){
              _this.driver.defineSteps(hiringStepsCS);

          } else if(window.location.pathname == '/onboarding'){
              _this.driver.defineSteps(onboardingStepsCS);

          } else if(window.location.pathname == '/onboarding/checklist'){
              _this.driver.defineSteps(onboardingChecklistStepsCS);

          } else if(window.location.pathname == '/talentpool'){
              _this.driver.defineSteps(talentpoolStepsCS);

          } else if(window.location.pathname.indexOf("dashboard") > -1){
              _this.driver.defineSteps(homepageStepsCS);

          } else if(window.location.pathname.indexOf("careersite") > -1) {
              _this.driver.defineSteps(careerSiteStepsCS);

          } else if(window.location.pathname.indexOf("/stranka") > -1){
              _this.driver.defineSteps(onboardingSiteStepsCS);

          } else {
            $("#start-guide").fadeOut();
          }

      }







        if(location.href.indexOf("#guide") != -1){
              _this.startGuide();
        }
        if (_this.getCookie('hide-guide')){

        } else {
              _this.startGuide();

        }

    }, 1000);

    // Call the below function
    if(window.location.pathname == '/hiring' || window.location.pathname == '/onboarding' || window.location.pathname == '/talentpool' || window.location.pathname == '/onboarding/checklist'){
        waitForElementToDisplay(".edit",function(){

            if(currentLang == "en"){
                if(window.location.pathname == '/hiring'){
                    _this.driver.defineSteps(hiringStepsEN);

                } else if(window.location.pathname == '/onboarding'){
                    _this.driver.defineSteps(onboardingStepsEN);

                } else if(window.location.pathname == '/onboarding/checklist'){
                    _this.driver.defineSteps(onboardingChecklistStepsEN);

                } else if(window.location.pathname == '/talentpool'){
                    _this.driver.defineSteps(talentpoolStepsEN);

                }

            } else if(currentLang == "sk"){
                if(window.location.pathname == '/hiring'){
                    _this.driver.defineSteps(hiringStepsSK);

                } else if(window.location.pathname == '/onboarding'){
                    _this.driver.defineSteps(onboardingStepsSK);

                } else if(window.location.pathname == '/onboarding/checklist'){
                    _this.driver.defineSteps(onboardingChecklistStepsSK);

                } else if(window.location.pathname == '/talentpool'){
                    _this.driver.defineSteps(talentpoolStepsSK);

                }
            } else {
                if(window.location.pathname == '/hiring'){
                    _this.driver.defineSteps(hiringStepsCS);

                } else if(window.location.pathname == '/onboarding'){
                    _this.driver.defineSteps(onboardingStepsCS);

                } else if(window.location.pathname == '/onboarding/checklist'){
                    _this.driver.defineSteps(onboardingChecklistStepsCS);

                } else if(window.location.pathname == '/talentpool'){
                    _this.driver.defineSteps(talentpoolStepsCS);

                }
            }



         },1000,9000);
    } else {
        setTimeout(function(){

          if(currentLang == "en"){
              if(window.location.pathname == '/jobs'){
                  _this.driver.defineSteps(careerStepsEN);

              } else if(window.location.pathname.indexOf("dashboard") > -1){
                  _this.driver.defineSteps(homepageStepsEN);

              } else if(window.location.pathname.indexOf("careersite") > -1) {
                  _this.driver.defineSteps(careerSiteStepsEN);

              } else if(window.location.pathname.indexOf("/stranka") > -1){
                  _this.driver.defineSteps(onboardingSiteStepsEN);

              }
          } else if(currentLang == "sk"){
              if(window.location.pathname == '/jobs'){
                  _this.driver.defineSteps(careerStepsSK);

              } else if(window.location.pathname.indexOf("dashboard") > -1){
                  _this.driver.defineSteps(homepageStepsSK);

              } else if(window.location.pathname.indexOf("careersite") > -1) {
                  _this.driver.defineSteps(careerSiteStepsSK);

              } else if(window.location.pathname.indexOf("/stranka") > -1){
                  _this.driver.defineSteps(onboardingSiteStepsSK);

              }
          } else {
              if(window.location.pathname == '/jobs'){
                  _this.driver.defineSteps(careerStepsCS);

              } else if(window.location.pathname.indexOf("dashboard") > -1){
                  _this.driver.defineSteps(homepageStepsCS);

              } else if(window.location.pathname.indexOf("careersite") > -1) {
                  _this.driver.defineSteps(careerSiteStepsCS);

              } else if(window.location.pathname.indexOf("/stranka") > -1){
                  _this.driver.defineSteps(onboardingSiteStepsCS);

              }

          }

            if(location.href.indexOf("#guide") != -1){
                  _this.startGuide();
            }
            if (_this.getCookie('hide-guide')){

            } else {
                  _this.startGuide();

            }

        }, 3500);
    }

    function waitForElementToDisplay(selector, callback, checkFrequencyInMs, timeoutInMs) {
      var startTimeInMs = Date.now();
      (function loopSearch() {
        if (document.querySelector(selector) != null) {
          callback();
          return;
        }
        else {
          setTimeout(function () {
            if (timeoutInMs && Date.now() - startTimeInMs > timeoutInMs)
              return;
            loopSearch();
          }, checkFrequencyInMs);
        }
      })();
    }




        $(window).scroll(function() {
            if($(window).scrollTop() + $(window).height() > $(document).height() - 200) {
                $('.support-floating-icon').addClass('scrolled-down');
            } else {
                $('.support-floating-icon').removeClass('scrolled-down');
            }
        });

  },
  methods: {
      getCookie(name) {
          var match = document.cookie.match(RegExp('(?:^|;\\s*)' + name + '=([^;]*)'));
          return match ? match[1] : null;
      },
      startGuide() {
          this.driver.start();
          $('body').addClass('guide-overlay');
      },
      stopGuide() {
          history.replaceState("", document.title, window.location.pathname);
          document.cookie = 'hide-guide=true; expires=Sun, 1 Jan 2100 00:00:00 UTC; path=/';
          $('body').removeClass('guide-overlay');
      },




  }
}
</script>
